import { render, staticRenderFns } from "./UpdateButton.vue?vue&type=template&id=5ad1e0df&scoped=true&"
import script from "./UpdateButton.vue?vue&type=script&lang=js&"
export * from "./UpdateButton.vue?vue&type=script&lang=js&"
import style0 from "./UpdateButton.vue?vue&type=style&index=0&id=5ad1e0df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad1e0df",
  null
  
)

export default component.exports